import { ModalManager } from './ModalManager.js';

export function scrollDisableOverlay(key) {
    const useKey = String(key || 'overlay');
    const tokenMap = $('body').data('overlayScrollTokens') || {};
    if (tokenMap[useKey]) {
        return false;
    }

    tokenMap[useKey] = ModalManager.open({
        name: 'overlay:' + useKey,
        locksScroll: true
    });
    $('body').data('overlayScrollTokens', tokenMap);

    return {
        key: useKey,
        token: tokenMap[useKey]
    };
}
export function scrollEnableOverlay(key) {
    const useKey = String(key || 'overlay');
    const tokenMap = $('body').data('overlayScrollTokens') || {};
    const token = tokenMap[useKey];
    if (!token) {
        return false;
    }

    ModalManager.close(token);
    delete tokenMap[useKey];
    $('body').data('overlayScrollTokens', tokenMap);

    return true;
}